// src/api/invoices.ts
import { opsHttp } from "../auth/apiClient.ts";
import type { Id } from "./_opResult.ts";
import type { InvoiceDto, UpdateInvoiceRequest } from "./dto.ts";

/** Инвойсы по одному ордеру */
export async function getInvoicesByOrder<T = InvoiceDto>(orderId: Id): Promise<T[]> {
  const { data } = await opsHttp.get<T[]>(`/api/Invoices/by-order/${orderId}`);
  return data ?? [];
}

/** Инвойсы по набору ордеров (map: orderId -> Invoice[]) */
export async function getInvoicesByOrders<T = InvoiceDto>(
  orderIds: Id[]
): Promise<Record<string, T[]>> {
  const ids = (orderIds ?? []).filter((v): v is Id => v !== undefined && v !== null);
  if (ids.length === 0) return {};
  const { data } = await opsHttp.post<Record<string, T[]>>(`/api/Invoices/by-orders`, { orderIds: ids });
  return data ?? {};
}

/** Удалить инвойс */
export async function deleteInvoice(id: Id): Promise<boolean> {
  const res = await opsHttp.delete(`/api/Invoices/${id}`);
  return res.status >= 200 && res.status < 300;
}

/**
 * Обновить инвойс
 * Ожидаются поля: platformId, invoiceExternalId, amountFiat, platformRate, amountUsdt,
 * а также предрасчитанные effectiveRate, percentToBb
 */
export async function updateInvoice(id: Id, payload: UpdateInvoiceRequest): Promise<boolean> {
  const res = await opsHttp.put(`/api/Invoices/${id}`, payload);
  return res.status >= 200 && res.status < 300;
}
